import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
// import NavBar from './Components/NavBar';
import { ThemeProvider } from './context/ThemeContext';
import Footer from './Components/Footer';
import Preloader from './Components/Preloader';
import { AnimatePresence } from 'framer-motion';
import ScrollToTop from './Components/ScrollToTop';

// Import pages
import Home from './pages/Home';
import Individuals from './pages/Individuals';
import Organisation from './pages/Organisation';

const AppContent = () => {
  // const location = useLocation();
  // const isHomePage = location.pathname === '/';

  return (
    <div className="flex flex-col min-h-screen bg-[#ffffff] dark:bg-[#000000]">
      {/* {!isHomePage && <NavBar />} */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/individuals" element={<Individuals />} />
          <Route path="/organisation" element={<Organisation />} />
        </Routes>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Function to handle when everything is loaded
    const handleLoad = () => {
      setIsLoading(false);
    };

    // If the document is already loaded, set loading to false
    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      // Add event listeners for different load states
      window.addEventListener('load', handleLoad);
      // Fallback in case load event doesn't fire
      document.addEventListener('readystatechange', () => {
        if (document.readyState === 'complete') {
          handleLoad();
        }
      });
    }

    // Cleanup
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return (
    <Router>
      <ThemeProvider>
        <div className="font-lexend">
          <AnimatePresence mode="wait">
            <Preloader isLoading={isLoading} />
          </AnimatePresence>
          {!isLoading && <AppContent />}
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;